const ClientsPage = () => import('./index.vue')
const ClientsFilter = () => import('./_pages/client_filter.vue')

export default [
  {
    path: '/clients',
    component: ClientsPage,
    name: 'ClientsIndex'
  },
  {
    path: '/clients/select/:filter',
    component: ClientsFilter,
    name: 'ClientsFilter'
  }
]
